<ml-status-message-popup-v2
  [popupInfo]="statusSuccessPopupElement"
  (closeEvent)="closeSuccessPopup()"
  (actionEvent)="goToDocument()"
>
</ml-status-message-popup-v2>
<ml-status-message-popup-v2 [popupInfo]="statusErrorPopupElement" (closeEvent)="closeErrorPopup()">
</ml-status-message-popup-v2>
<div class="container gap-override">
  <ml-card-container [title]="'application.paper-delivery.title' | translate" [icon]="'digital-signature'">
    <ml-information-card [text]="'application.paper-delivery.information' | translate" />
    <div class="content">
      <div class="consent">
        <h2>{{ 'application.paper-delivery.consent.title' | translate }}</h2>
        <mat-checkbox [(ngModel)]="isDopcChecked">
          <span>{{ 'application.paper-delivery.consent.transmission-allowed' | translate }}</span>
        </mat-checkbox>
        <mat-checkbox [(ngModel)]="isGdprChecked">
          <span>{{ 'application.paper-delivery.consent.no-prospection' | translate }}</span>
        </mat-checkbox>
        <mat-checkbox [(ngModel)]="isOptInChecked">
          <span>{{ 'application.paper-delivery.consent.offer-ok' | translate }}</span>
        </mat-checkbox>
      </div>
      <form novalidate (submit)="$event.preventDefault();">
        <div class="characteristics">
          <h2>{{ 'application.paper-delivery.caracteristics.title' | translate }}</h2>
          @if (isVehicleCategoryEligibleToImmat()) {
            <ml-text-signal-input
              [formField]="paperDeliveryForm.numImmat"
              mlToUppercaseSignal
              [mlLiveControlRegexSignal]="immatRegex"
              [toggleValidationIcon]="true"
              [label]="
                `application.paper-delivery.caracteristics.num-immat${isVehicleUsed() ? '' : '-optional'}`
                  | translate
              "
              [placeholder]="'application.paper-delivery.caracteristics.num-immat-placeholder' | translate"
            >
            </ml-text-signal-input>
          }
          @if (isFetchVehicleLoading()) {
            <ml-custom-line-skeleton
              class="skeleton grow-flex-1"
              [label]="'application.paper-delivery.caracteristics.num-vin' | translate"
              [customHeight]="5.4"
            ></ml-custom-line-skeleton>
          } @else {
            <ml-text-signal-input
              [formField]="paperDeliveryForm.numVin"
              mlToUppercaseSignal
              [maxlength]="17"
              [mlControlRegexSignal]="vinRegex"
              [toggleValidationIcon]="true"
              [label]="'application.paper-delivery.caracteristics.num-vin' | translate"
              [placeholder]="'application.paper-delivery.caracteristics.num-vin-placeholder' | translate"
            >
            </ml-text-signal-input>
          }
        </div>
      </form>
    </div>
    <div class="footer">
      <div class="information">{{ 'application.paper-delivery.footer.information' | translate }}</div>
      <ml-loading-button
        [label]="'application.paper-delivery.footer.button' | translate"
        [disabled]="disableButtonFinancing"
        [loading]="loadingFinancingRequest()"
        (event)="financeRequest()"
      ></ml-loading-button>
    </div>
  </ml-card-container>
</div>
